<template>
  <div ref="pinTemplate">
    <slot v-if="initialized"></slot>
  </div>
</template>

<script>
import Utils from '../utils'
import BingConversions from '../services/BingConversions'
import ComponentBase from './ComponentBase'

const pushpinEvents = Object.freeze([
  'changed',
  'click',
  'dblclick',
  'drag',
  'dragend',
  'dragstart',
  'mousedown',
  'mouseout',
  'mouseover',
  'mouseup'
])

export default {
  name: 'bing-map-pushpin',
  mixins: [ComponentBase],
  props: {
    options: {
      type: Object,
      required: false,
      default: () => {}
    },
    location: {
      type: Object,
      required: true,
      validator: value =>
        value &&
        typeof value.latitude === 'number' &&
        typeof value.longitude === 'number'
    }
  },
  data () {
    return {
      itemType: 'push-pin',
      initialized: true,
      allowedEvents: pushpinEvents
    }
  },
  computed: {
    innerOptions () {
      let source = this.options
      let target = {}

      for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
          switch (prop) {
            case 'anchor':
            case 'textOffset':
              target[prop] = BingConversions.toMapPoint(source[prop])
              break
            default:
              target[prop] = Utils.deepClone(source[prop])
              break
          }
        }
      }

      return target
    }
  },
  watch: {
    location (value) {
      let pin = this.getItem()
      if (pin) {
        pin.setLocation(BingConversions.toMapLocation(value))
      }
    },
    innerOptions (value) {
      let pin = this.getItem()
      if (pin) {
        pin.setOptions(value)
      }
    }
  },
  inject: ['getLayer'],
  methods: {
    hasIconTemplate () {
      return !!(
        this.$slots &&
        this.$slots.default &&
        this.$slots.default.length
      )
    },
    render () {
      let layer = this.getLayer()
      let pin = this.getItem()

      if (layer) {
        if (pin) {
          this.destroy()
        }

        let options = Utils.deepClone(this.innerOptions)

        pin = this.setItem(
          new Microsoft.Maps.Pushpin(
            BingConversions.toMapLocation(this.location),
            options
          )
        )

        this.updateIcon()

        layer.add(pin)
      }
    },
    updateIcon () {
      if (this.hasIconTemplate()) {
        let pin = this.getItem()
        if (pin) {
          let template = this.$refs.pinTemplate.innerHTML
          pin.setOptions({ icon: template })
        }
      }
    },
    destroy () {
      let pin = this.getItem()

      try {
        if (pin) {
          let layer = this.getLayer()

          if (layer) {
            layer.remove(pin)
          }
        }
      } finally {
        this.setItem(null)
      }
    }
  },
  mounted () {
    this.render()
    this.registerEvents()
  },
  updated () {
    this.updateIcon()
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>
